
import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database.types';

const supabaseUrl = 'https://rrsgsfpxfwcnlttxnlom.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyc2dzZnB4Zndjbmx0dHhubG9tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE2MDcyNjYsImV4cCI6MjA1NzE4MzI2Nn0.Pn3ZDQ3Dv75CQXk0QfQEd9awOEVIUIFgVliM2sMxcJI';

// Create Supabase client with timeout options
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Add proper redirect URLs for auth flow
    flowType: 'pkce', // Using PKCE flow for better security
    detectSessionInUrl: true, // Detect auth parameters in URL
  },
  global: {
    // Increase timeouts to prevent "Failed to fetch" for slower connections
    fetch: (url, options) => {
      return fetch(url, {
        ...options,
        // Increase timeout to 30 seconds
        signal: options?.signal || (() => {
          const controller = new AbortController();
          setTimeout(() => controller.abort(), 30000); // 30 second timeout
          return controller.signal;
        })(),
      });
    },
  },
});
